var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 69,
    viewBox: "0 0 106 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96523 0.511017C2.7755 0.511017 0.995972 2.38466 0.995972 4.51081V54.5126C0.995972 56.6395 2.77547 58.5124 4.96523 58.5124H87.0307C89.2205 58.5124 91 56.6388 91 54.5126V4.51081C91 2.38394 89.2205 0.511017 87.0307 0.511017H4.96523ZM6.99655 6.51159H84.9994V7.94929L45.998 35.795L6.99655 7.94929V6.51159ZM6.99655 15.3553L44.2479 41.9509H44.2472C44.7571 42.3172 45.3696 42.5139 45.9974 42.5139C46.6252 42.5139 47.2377 42.3171 47.7476 41.9509L84.999 15.3553V52.512H6.99614L6.99655 15.3553Z",
    fill: "#F4D257"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 50,
    r: 19,
    fill: "#303952"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0526 58.0148V59.4099H75V58.0148L77.8988 55.1567V48.1133C77.8988 45.8902 78.4625 43.9734 79.5898 42.3629C80.7402 40.7069 82.3391 39.6294 84.3867 39.1304V38.1436C84.3867 37.5539 84.5938 37.0491 85.0079 36.6295C85.422 36.2098 85.9282 36 86.5263 36C87.1245 36 87.6364 36.2098 88.062 36.6295C88.4876 37.0491 88.7004 37.5539 88.7004 38.1436V39.1304C90.725 39.6294 92.3125 40.7183 93.4628 42.3969C94.5901 44.0075 95.1538 45.9129 95.1538 48.1133V55.1567L98.0526 58.0148ZM88.5623 62.8465C87.9872 63.3909 87.3085 63.6631 86.5262 63.6631C85.721 63.6631 85.0366 63.3909 84.4729 62.8465C83.9092 62.3021 83.6274 61.6443 83.6274 60.873H89.4251C89.4251 61.6443 89.1375 62.3021 88.5623 62.8465Z",
    fill: "#F4D257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.ba787d31c92d92276d3925d5b00717cc.svg";
export { ForwardRef as ReactComponent };